import { render, staticRenderFns } from "./PromptConfirm.vue?vue&type=template&id=01a5ec3e&scoped=true&"
import script from "./PromptConfirm.vue?vue&type=script&lang=js&"
export * from "./PromptConfirm.vue?vue&type=script&lang=js&"
import style0 from "./PromptConfirm.vue?vue&type=style&index=0&id=01a5ec3e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a5ec3e",
  null
  
)

export default component.exports